import { render, staticRenderFns } from "./MeldingSucces.vue?vue&type=template&id=78a9fc68&"
import script from "./MeldingSucces.vue?vue&type=script&lang=js&"
export * from "./MeldingSucces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports